import { useCallback, useMemo } from 'react';
import useLocalStorage from 'react-localstorage-hook';

import { VAULTS_VIEW } from '@constants/common/localStorage.constants';
import { ViewModes } from '@constants/vaults/common.constants';

export const useViewMode = () => {
  const [viewMode, setViewMode] = useLocalStorage(VAULTS_VIEW);

  const onChangeMode = useCallback((view: ViewModes) => {
    setViewMode(view);
  }, []);

  const isGridMode = useMemo(() => viewMode === ViewModes.Grid, [viewMode]);

  const isListMode = useMemo(() => viewMode === ViewModes.List, [viewMode]);

  return {
    viewMode,
    isGridMode,
    isListMode,
    onChangeMode,
  };
};
